import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import Document from '../../../components/document';
import { Signatures } from '../../../utilities/signatureTypes';
import { getSignatures } from '../../../reducers/signatures';
import { getDocumentsForce } from '../../../reducers/documents';
import { DocumentInfo } from '../../../utilities/documentTypes';
import { beginsWith } from '../../../utilities/string';

class ContractorAllDocs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { role, getDocumentsForce, getSignatures } = this.props;
        getSignatures(role);
        getDocumentsForce(role);
    }

    render() {
        const { role, signatures, documents } = this.props;
        if (!signatures || !documents) {
            return null;
        }

        const { ADMIN_PAY_STUB, CONTRACTOR_USA_I9_SIGNED } = DocumentInfo.types;

        const mappedSignatures = signatures.map(signature => ({
            ...signature,
            signatureType: Map(Signatures.types).find(s => beginsWith(signature.name, s.name))
        }));
        const docsWithSignatures = documents.map(d => ({
            ...d,
            signature: mappedSignatures.find(m => m.signatureType && m.signatureType.document && m.signatureType.document.docType === d.doc_type)
        }));

        return (
            <div className="row">
                <div className="col-xs-12">
                    <Document
                        id={`${role.id}-${role.type}-all-documents`}
                        docType={''}
                        excludeDocTypes={[ADMIN_PAY_STUB.docType, CONTRACTOR_USA_I9_SIGNED.docType]}
                        providedDocuments={docsWithSignatures}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const role = state.identity.role;
    const prop = `${role.id}-all`;
    let documents = state.documents[prop];
    if ((documents || {}).list) {
        documents.list = documents.list.filter(d => !['never', 'later'].includes(d.status));
    }
    return {
        role,
        documents: documents ? documents.list : undefined,
        signatures: state.signatures.list
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getSignatures,
            getDocumentsForce
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorAllDocs);



// WEBPACK FOOTER //
// ./src/pages/documents/tabs/contractorAllDocs.jsx